import { Record as record } from 'immutable';

import { resolve } from '../helpers/LinkMapper';

import Railcard from './Railcard';
import TicketType from './TicketType';


const defaults = {
    adults: 0,
    children: 0,
    price: null,
    railcard: new Railcard(),
    railcardDiscount: 0,
    ticketTypeOverride: null,
    statusCode: null,
    amended: false,
    promotionalDiscountId: null
};


class Ticket extends record(defaults) {

    static fromJSON (json = {}) {
        return new Ticket({
            adults: resolve(json.adults).with(Number),
            children: resolve(json.children).with(Number),
            price: resolve(json.price).with(Number),
            railcard: resolve(json.railcard).as(Railcard),
            railcardDiscount: resolve(json.railcardDiscount).with(Number),
            ticketTypeOverride: resolve(json.ticketTypeOverride).as(TicketType),
            statusCode: resolve(json.statusCode).with(String),
            amended: resolve(json.amended).with(Boolean),
            promotionalDiscountId: resolve(json.promotionalDiscountId).with(Number)
        });
    }

    isGroupSave () {
        return this.railcard && this.railcard.isGroupSave();
    }

    hasRailcard (railcard) {
        return this.railcard && this.railcard.code === railcard.code;
    }

    hasPromoDiscount() {
        return !!this.promotionalDiscountId;
    }
}

export default Ticket;
